const serviceWorkerURL = `${process.env.REACT_APP_PUBLIC_URL}/firebase-messaging-sw.js`

const scopeURL = window.location.origin

const scope = `${scopeURL}/booking/firebase-cloud-messaging-push-scope`

export async function registerServiceWorker () {
  if ('serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.register(
      serviceWorkerURL,
      { scope },
    )

    return registration
  }
}

export async function checkExistServiceWorker () {
  const allRegistrations = await navigator.serviceWorker.getRegistrations()
  let allServiceWorkers = null
  
  if (allRegistrations.length > 0 && scopeURL !== null) {
    allServiceWorkers = allRegistrations.filter(
      (registration) => registration.active.scriptURL === `${scopeURL}${serviceWorkerURL}`
    )
  }

  const result = {
    allServiceWorkers,
    isExistServiceWorker: allServiceWorkers !== null && allServiceWorkers.length > 0 ? true : false,
  }

  return result
}

export const initServiceWorker = async () => {
  try {
    const { isExistServiceWorker } = await checkExistServiceWorker()

    if (isExistServiceWorker) {
      throw new Error('initServiceWorker ERROR ==> service worker exists')
    }

    const publicUrl = new URL(process.env.REACT_APP_PUBLIC_URL, window.location)
    
    if (publicUrl.origin !== window.location.origin) {
      return
    }
    
    const serviceWorkerRegistration = await registerServiceWorker()

    return serviceWorkerRegistration
  } catch (error) {
    console.error('Service Worker registration failed:', error)
  }
}

export async function unregisterServiceWorker () {
  const { allServiceWorkers } = await checkExistServiceWorker()

  if (!allServiceWorkers) {
    return
  }
  
  allServiceWorkers.forEach(async (serviceWorker) => {
    await serviceWorker.unregister()
  })
}
